import { CHROME } from "./chrome.js";
import { CONTENT } from "./content.js";
import { REPORT_GENERATION } from "./reportGeneration.js";

const STORAGE_KEY = "sfcr:lang";
const DEFAULT_LOCALE = "fr";
export const LOCALES = ["fr", "en"];
const LOCALE_NAMES = { fr: "Français", en: "English" };

const DICT = {
  fr: { ...CHROME.fr, ...CONTENT.fr, ...REPORT_GENERATION.fr },
  en: { ...CHROME.en, ...CONTENT.en, ...REPORT_GENERATION.en },
};

function readLocale() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (LOCALES.includes(stored)) return stored;
  } catch {
    /* private mode / disabled storage */
  }
  return DEFAULT_LOCALE;
}

let locale = readLocale();
if (typeof document !== "undefined") document.documentElement.lang = locale;

export function getLocale() {
  return locale;
}

export function setLocale(next) {
  if (!LOCALES.includes(next) || next === locale) return;
  locale = next;
  try {
    localStorage.setItem(STORAGE_KEY, next);
  } catch {
    /* private mode / disabled storage */
  }
  document.documentElement.lang = next;
  window.dispatchEvent(new CustomEvent("sfcr:render"));
}

export function t(key: string, params: Record<string, unknown> = {}) {
  const entry = DICT[locale]?.[key] ?? DICT[DEFAULT_LOCALE]?.[key];
  if (entry === undefined) return key;
  return typeof entry === "function" ? entry(params || {}) : entry;
}

// Like t(), but for keys built from captured-data ids: falls back to the
// original (French) source value instead of the raw key when untranslated.
export function tc(key: string, fallback: string, params: Record<string, unknown> = {}) {
  const entry = DICT[locale]?.[key] ?? DICT[DEFAULT_LOCALE]?.[key];
  if (entry === undefined) return fallback;
  return typeof entry === "function" ? entry(params || {}) : entry;
}

export function languageSwitcher(extraClass = "") {
  return `<div class="lang-switch ${extraClass}" role="group" aria-label="${t("lang.switchLabel")}">${LOCALES.map(
    (code) =>
      `<button type="button" class="lang-btn ${code === locale ? "active" : ""}" data-lang="${code}" title="${LOCALE_NAMES[code]}">${code.toUpperCase()}</button>`,
  ).join("")}</div>`;
}

export function bindLanguageSwitcher(root = document) {
  root.querySelectorAll<HTMLElement>("[data-lang]").forEach((button) =>
    button.addEventListener("click", () => setLocale(button.dataset.lang)),
  );
}
